import { rem } from 'polished'
import styled from 'styled-components'

import RoomDetails from '../Common/RoomDetails'

import FoldableContent from 'components/Common/FoldableContent/FoldableContent'
import { BaseImage } from 'components/Common/OrderView/styles'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import { useIntl } from 'react-intl'

const BookingDetails = styled.div`
  padding: ${rem(20)} 0;
  display: flex;
  flex-direction: column;
  gap: ${rem(20)};
`

interface Prop {
  offer: App.Offer
  pkg: App.Package
}

function PlannedLeOfferPackageSummary({ offer, pkg }: Prop) {
  const intl = useIntl()

  const yourPackageHeading = intl.formatMessage({
    id: '7SgsTKqsj9dNQc-jjSqI',
    defaultMessage: 'Your Package',
    description: 'Heading for the planned LE offer package summary section',
  })

  const hideDetailsLabel = intl.formatMessage({
    id: 'WROTB4yfWNTtJqEHuisy',
    defaultMessage: 'Hide package and room details',
    description: 'Button text to collapse the package and room details section',
  })

  const viewDetailsLabel = intl.formatMessage({
    id: 'hshw9v-0r9nl57Ju-BiU',
    defaultMessage: 'View package and room details',
    description: 'Button text to expand the package and room details section',
  })

  const imageId = pkg.roomType?.images[0]?.id || offer.image.id
  return (
    <BookingDetails>
      <Heading variant="heading5">{yourPackageHeading}</Heading>
      {imageId && (
        <BaseImage
          className="hidden-print"
          id={imageId}
          mobileAspectRatio="9:4"
          mobileWidth="100"
        />
      )}
      <BodyText variant="medium" weight="bold">
        {pkg.name}
      </BodyText>
      {pkg.roomType && (
        <BodyText variant="medium">{pkg.roomType?.name}</BodyText>
      )}
      <FoldableContent
        openLabel={hideDetailsLabel}
        closedLabel={viewDetailsLabel}
      >
        <RoomDetails pkg={pkg} />
      </FoldableContent>
    </BookingDetails>
  )
}

export default PlannedLeOfferPackageSummary
